import React from "react";
import { Check, Award } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { Button } from "./ui/button";

const About = () => {
  const { content } = useContent();
  const company = content.company || {};
  const services = content.services || [];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-32 h-32 bg-[#b91c1c]/5 rounded-2xl -z-10" />
          <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-[#b91c1c]/5 rounded-2xl -z-10" />
          <img
            loading="lazy"
            decoding="async"
            src="https://images.pexels.com/photos/27083552/pexels-photo-27083552.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
            alt="Aktav Yarka çiftliği"
            className="rounded-2xl shadow-xl w-full h-[460px] object-cover"
          />
          <div className="absolute -bottom-8 left-8 bg-white rounded-2xl shadow-2xl p-5 flex items-center gap-4 border border-slate-100">
            <div className="w-14 h-14 rounded-xl bg-[#b91c1c] flex items-center justify-center">
              <Award className="w-7 h-7 text-white" />
            </div>
            <div>
              <div className="text-2xl font-black text-[#b91c1c] leading-none">{company.yearsExp}</div>
              <div className="text-xs text-slate-500 mt-1">Yıllık Tecrübe</div>
            </div>
          </div>
        </div>

        <div>
          <span className="inline-block text-xs font-semibold tracking-[0.25em] text-[#b91c1c] uppercase mb-4">— Hakkımızda</span>
          <h2 className="text-3xl md:text-4xl font-black text-[#b91c1c] leading-tight mb-5">
            Kurumsal Çözüm, <br className="hidden md:block" />Kaliteli Hizmet
          </h2>
          <p className="text-slate-600 leading-relaxed mb-4">
            <span className="font-bold text-[#b91c1c]">{company.name}</span> olarak, 15 yılı aşkın tecrübemiz ve üretim gücümüzle Türkiye'nin en kaliteli yarka ve tavuklarını üretiyor; profesyonel, anahtar teslim tavuk kümesleri kuruyoruz.
          </p>
          <p className="text-slate-600 leading-relaxed mb-6">
            Salma ve gezen tavukçuluk ciddi bir sektördür. Üreticisi olduğumuz ırkları sağlıklı, aşı kartlı ve veteriner kontrolünde sizlere ulaştırıyoruz. Firmamızla ticaretiniz olsun ya da olmasın, ücretsiz teknik bilgi almaktan çekinmeyin.
          </p>

          <div className="grid sm:grid-cols-2 gap-3 mb-8">
            {services.map((s, i) => (
              <div key={i} className="flex items-start gap-3">
                <span className="mt-0.5 w-5 h-5 rounded-md bg-[#b91c1c] flex items-center justify-center shrink-0">
                  <Check className="w-3 h-3 text-white" strokeWidth={3} />
                </span>
                <span className="text-sm text-slate-700 font-medium">{s}</span>
              </div>
            ))}
          </div>

          <Button asChild size="lg" className="bg-[#b91c1c] hover:bg-[#991b1b] text-white px-7 h-12">
            <a href="#contact">Bilgi Alın</a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default About;
